"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MarketplaceConfigAsyncClientImpl = /** @class */ (function () {
    function MarketplaceConfigAsyncClientImpl(configSet) {
        this.configSet = configSet;
    }
    MarketplaceConfigAsyncClientImpl.prototype.getMarketplace = function (context, weblabContext) {
        return this.configSet.getObject("marketplace", context === null || context === void 0 ? void 0 : context.toRawContext(), weblabContext);
    };
    return MarketplaceConfigAsyncClientImpl;
}());
exports.default = MarketplaceConfigAsyncClientImpl;
